import { SetupPermission } from 'src/app/core';
import { PermissionsC } from 'src/permissions/helpers/permissions.class';

export const EndSellerNetwork: SetupPermission = PermissionsC.setupPages({
  pageLabels: ['end-seller-management'],
  productLineLabel: 'end-seller-network',
});
